module.exports = __webpack_public_path__ + "img/symbol_13.429ef90b.png";